<template>
  <div class="detail-sign-info">
    <div class="heard">
      <el-form :inline="true" :model="signInfo">
        <div class="sign-form clearfix">
          <div class="top-box">
            <div class="form-item item_bto">
              <el-form-item label="申报单位:">
                <el-input
                  placeholder="请输入申报单位"
                  v-model="companyName"
                  class="namee"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="用户名:">
                <el-input
                  placeholder="请输入用户名"
                  v-model="userName"
                  class="namee"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input
                  placeholder="请输入手机号"
                  v-model="phone"
                  clearable
                ></el-input>
              </el-form-item>
			  <el-form-item label="所属城市:" class="item-short">
			  <el-select
				v-model="cityCode"
				placeholder="请选择城市"
				clearable
			  >
				<el-option
				  v-for="item in codeListArr"
				  :key="item.code"
				  :label="item.areaName"
				  :value="item.code"
				>
				</el-option>
			  </el-select>
			  </el-form-item>
            </div>
            <div class="form-item item_btn" style="margin-left: 10px">
              <el-form-item
                ><el-button type="primary" @click="initList(1)">
                  查询
                </el-button>
                <el-button type="warning" @click="chongzhi"> 重置 </el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <el-row
        :style="{ marginTop: '5px', marginBottom: '10px' }"
        align="middle"
        type="flex"
        class="row-bg"
      >
        <el-button
          type="info"
          size="small"
          @click="goBack"
          icon="el-icon-arrow-left"
          >返回</el-button
        >
        <!-- <el-button type="info" @click="getcommand"> 导出到excel </el-button> -->
      </el-row>
	  
    </div>
    <el-table
      :data="personList"
      border
      style="width: 100%"
      stripe
      id="tableform"
    >
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column
        type="index"
        align="center"
        width="60"
        :index="(signInfo.commonDto.page - 1) * signInfo.commonDto.limit + 1"
        label="ID"
      >
      </el-table-column>
      <!-- <div class="" v-for="(item, index) in mubanlist.input" :key="index">
        <el-table-column
          :label="item.name"
          align="center"
          width="100"
          show-overflow-tooltip
          :prop="item.attribute"
        >
        </el-table-column>
      </div> -->
      <el-table-column
        label="申报单位"
        align="left"
	    width="300"
      >
        <template slot-scope="scope">
		    【{{codeListObj[scope.row.city_code]}}】
		    {{scope.row.company_name}}<br />
		    申报商品: {{scope.row.product_name}}<br />
			申报时间: {{scope.row.create_time}}<br />
        </template>
      </el-table-column>
      <el-table-column
        label="联系信息"
        align="center"
	    width="120"
      >
        <template slot-scope="scope">
		    {{scope.row.contact_user}}<br />
		    {{scope.row.contact_phone}}<br />
<!-- 			<span v-for="(item, index) in scope.row.pingtai" :key="index">
			  {{item}}
			</span> -->
        </template>
      </el-table-column>
	  
	  
	  
	  <el-table-column
	    label="数据资料"
	    align="center"
	    show-overflow-tooltip
	  >
	    <template slot-scope="scope">
		  <!-- 淘宝 -->
	      <div class="infoDetail" v-if="scope.row.salestaobao > 0 || scope.row.taobaosales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('淘宝销售额('+scope.row.salestaobao+')')">
					  <label>淘宝销售额</label>
					  {{scope.row.salestaobao}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.taobaosales_imgs)">
				    <el-image
				      v-if="scope.row.taobaosales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.taobaosales_imgs[0]"
				      :preview-src-list="scope.row.taobaosales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('淘宝买家数('+scope.row.buyertaobao+')')">
					  <label>淘宝买家数</label>
					  {{scope.row.buyertaobao}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.taobaobuyer_imgs)">
				    <el-image
				      v-if="scope.row.taobaobuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.taobaobuyer_imgs[0]"
				      :preview-src-list="scope.row.taobaobuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 天猫 -->
	      <div class="infoDetail" v-if="scope.row.salestianmao > 0 || scope.row.tianmaosales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('天猫销售额('+scope.row.salestianmao+')')">
					  <label>天猫销售额</label>
					  {{scope.row.salestianmao}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.tianmaosales_imgs)">
				    <el-image
				      v-if="scope.row.tianmaosales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.tianmaosales_imgs[0]"
				      :preview-src-list="scope.row.tianmaosales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('天猫买家数('+scope.row.buyertianmao+')')">
				  				  <label>天猫买家数</label>
				  				  {{scope.row.buyertianmao}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.tianmaobuyer_imgs)">
				    <el-image
				      v-if="scope.row.tianmaobuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.tianmaobuyer_imgs[0]"
				      :preview-src-list="scope.row.tianmaobuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 拼多多 -->
	      <div class="infoDetail" v-if="scope.row.salespinduoduo > 0 || scope.row.pinduoduosales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('拼多多销售额('+scope.row.salespinduoduo+')')">
				  				  <label>拼多多销售额</label>
				  				  {{scope.row.salespinduoduo}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.pinduoduosales_imgs)">
				    <el-image
				      v-if="scope.row.pinduoduosales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.pinduoduosales_imgs[0]"
				      :preview-src-list="scope.row.pinduoduosales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('拼多多买家数('+scope.row.buyerpinduoduo+')')">
					  <label>拼多多买家数</label>
					  {{scope.row.buyerpinduoduo}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.pinduoduobuyer_imgs)">
				    <el-image
				      v-if="scope.row.pinduoduobuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.pinduoduobuyer_imgs[0]"
				      :preview-src-list="scope.row.pinduoduobuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 京东 -->
	      <div class="infoDetail" v-if="scope.row.salesjingdong > 0 || scope.row.jingdongsales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('京东销售额('+scope.row.salesjingdong+')')">
					  <label>京东销售额</label>
					  {{scope.row.salesjingdong}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.jingdongsales_imgs)">
				    <el-image
				      v-if="scope.row.jingdongsales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.jingdongsales_imgs[0]"
				      :preview-src-list="scope.row.jingdongsales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('京东买家数('+scope.row.buyerjingdong+')')">
					  <label>京东买家数</label>
					  {{scope.row.buyerjingdong}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.jingdongbuyer_imgs)">
				    <el-image
				      v-if="scope.row.jingdongbuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.jingdongbuyer_imgs[0]"
				      :preview-src-list="scope.row.jingdongbuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 抖音 -->
	      <div class="infoDetail" v-if="scope.row.salesdouyin > 0 || scope.row.douyinsales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('抖音销售额('+scope.row.salesdouyin+')')">
					  <label>抖音销售额</label>
					  {{scope.row.salesdouyin}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.douyinsales_imgs)">
				    <el-image
				      v-if="scope.row.douyinsales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.douyinsales_imgs[0]"
				      :preview-src-list="scope.row.douyinsales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('抖音买家数('+scope.row.buyerdouyin+')')">
					  <label>抖音买家数</label>
					  {{scope.row.buyerdouyin}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.douyinbuyer_imgs)">
				    <el-image
				      v-if="scope.row.douyinbuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.douyinbuyer_imgs[0]"
				      :preview-src-list="scope.row.douyinbuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 快手 -->
	      <div class="infoDetail" v-if="scope.row.saleskuaishou > 0 || scope.row.kuaishousales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('快手销售额('+scope.row.saleskuaishou+')')">
					  <label>快手销售额</label>
					  {{scope.row.saleskuaishou}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.kuaishousales_imgs)">
				    <el-image
				      v-if="scope.row.kuaishousales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.kuaishousales_imgs[0]"
				      :preview-src-list="scope.row.kuaishousales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal('快手买家数('+scope.row.buyerkuaishou+')')">
					  <label>快手买家数</label>
					  {{scope.row.buyerkuaishou}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.kuaishoubuyer_imgs)">
				    <el-image
				      v-if="scope.row.kuaishoubuyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.kuaishoubuyer_imgs[0]"
				      :preview-src-list="scope.row.kuaishoubuyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他1 -->
	      <div class="infoDetail" v-if="scope.row.salesqita1 > 0 || scope.row.qita1sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita1name+'销售额('+scope.row.salesqita1+')')">
					  <label>{{scope.row.qita1name}}销售额</label>
					  {{scope.row.salesqita1}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita1sales_imgs)">
				    <el-image
				      v-if="scope.row.qita1sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita1sales_imgs[0]"
				      :preview-src-list="scope.row.qita1sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita1name+'买家数('+scope.row.buyerqita1+')')">
					  <label>{{scope.row.qita1name}}买家数</label>
					  {{scope.row.buyerqita1}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita1buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita1buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita1buyer_imgs[0]"
				      :preview-src-list="scope.row.qita1buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他2 -->
	      <div class="infoDetail" v-if="scope.row.salesqita2 > 0 || scope.row.qita2sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita2name+'销售额('+scope.row.salesqita2+')')">
					  <label>{{scope.row.qita2name}}销售额</label>
					  {{scope.row.salesqita2}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita2sales_imgs)">
				    <el-image
				      v-if="scope.row.qita2sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita2sales_imgs[0]"
				      :preview-src-list="scope.row.qita2sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita2name+'买家数('+scope.row.buyerqita2+')')">
					  <label>{{scope.row.qita2name}}买家数</label>
					  {{scope.row.buyerqita2}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita2buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita2buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita2buyer_imgs[0]"
				      :preview-src-list="scope.row.qita2buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他3 -->
	      <div class="infoDetail" v-if="scope.row.salesqita3 > 0 || scope.row.qita3sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita3name+'销售额('+scope.row.salesqita3+')')">
					  <label>{{scope.row.qita3name}}销售额</label>
					  {{scope.row.salesqita3}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita3sales_imgs)">
				    <el-image
				      v-if="scope.row.qita3sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita3sales_imgs[0]"
				      :preview-src-list="scope.row.qita3sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita3name+'买家数('+scope.row.buyerqita3+')')">
					  <label>{{scope.row.qita3name}}买家数</label>
					  {{scope.row.buyerqita3}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita3buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita3buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita3buyer_imgs[0]"
				      :preview-src-list="scope.row.qita3buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他4 -->
	      <div class="infoDetail" v-if="scope.row.salesqita4 > 0 || scope.row.qita4sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita4name+'销售额('+scope.row.salesqita4+')')">
					  <label>{{scope.row.qita4name}}销售额</label>
					  {{scope.row.salesqita4}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita4sales_imgs)">
				    <el-image
				      v-if="scope.row.qita4sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita4sales_imgs[0]"
				      :preview-src-list="scope.row.qita4sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita4name+'买家数('+scope.row.buyerqita4+')')">
					  <label>{{scope.row.qita4name}}买家数</label>
					  {{scope.row.buyerqita4}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita4buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita4buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita4buyer_imgs[0]"
				      :preview-src-list="scope.row.qita4buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他5 -->
	      <div class="infoDetail" v-if="scope.row.salesqita5 > 0 || scope.row.qita5sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita5name+'销售额('+scope.row.salesqita5+')')">
					  <label>{{scope.row.qita5name}}销售额</label>
					  {{scope.row.salesqita5}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita5sales_imgs)">
				    <el-image
				      v-if="scope.row.qita5sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita5sales_imgs[0]"
				      :preview-src-list="scope.row.qita5sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita5name+'买家数('+scope.row.buyerqita5+')')">
					  <label>{{scope.row.qita5name}}买家数</label>
					  {{scope.row.buyerqita5}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita5buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita5buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita5buyer_imgs[0]"
				      :preview-src-list="scope.row.qita5buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他6 -->
	      <div class="infoDetail" v-if="scope.row.salesqita6 > 0 || scope.row.qita6sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita6name+'销售额('+scope.row.salesqita6+')')">
					  <label>{{scope.row.qita6name}}销售额</label>
					  {{scope.row.salesqita6}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita6sales_imgs)">
				    <el-image
				      v-if="scope.row.qita6sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita6sales_imgs[0]"
				      :preview-src-list="scope.row.qita6sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita6name+'买家数('+scope.row.buyerqita6+')')">
					  <label>{{scope.row.qita6name}}买家数</label>
					  {{scope.row.buyerqita6}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita6buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita6buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita6buyer_imgs[0]"
				      :preview-src-list="scope.row.qita6buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他7 -->
	      <div class="infoDetail" v-if="scope.row.salesqita7 > 0 || scope.row.qita7sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita7name+'销售额('+scope.row.salesqita7+')')">
					  <label>{{scope.row.qita7name}}销售额</label>
					  {{scope.row.salesqita7}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita7sales_imgs)">
				    <el-image
				      v-if="scope.row.qita7sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita7sales_imgs[0]"
				      :preview-src-list="scope.row.qita7sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita7name+'买家数('+scope.row.buyerqita7+')')">
					  <label>{{scope.row.qita7name}}买家数</label>
					  {{scope.row.buyerqita7}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita7buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita7buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita7buyer_imgs[0]"
				      :preview-src-list="scope.row.qita7buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他8 -->
	      <div class="infoDetail" v-if="scope.row.salesqita8 > 0 || scope.row.qita8sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita8name+'销售额('+scope.row.salesqita8+')')">
					  <label>{{scope.row.qita8name}}销售额</label>
					  {{scope.row.salesqita8}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita8sales_imgs)">
				    <el-image
				      v-if="scope.row.qita8sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita8sales_imgs[0]"
				      :preview-src-list="scope.row.qita8sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita8name+'买家数('+scope.row.buyerqita8+')')">
					  <label>{{scope.row.qita8name}}买家数</label>
					  {{scope.row.buyerqita8}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita8buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita8buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita8buyer_imgs[0]"
				      :preview-src-list="scope.row.qita8buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他9 -->
	      <div class="infoDetail" v-if="scope.row.salesqita9 > 0 || scope.row.qita9sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita9name+'销售额('+scope.row.salesqita9+')')">
					  <label>{{scope.row.qita9name}}销售额</label>
					  {{scope.row.salesqita9}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita9sales_imgs)">
				    <el-image
				      v-if="scope.row.qita9sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita9sales_imgs[0]"
				      :preview-src-list="scope.row.qita9sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita9name+'买家数('+scope.row.buyerqita9+')')">
					  <label>{{scope.row.qita9name}}买家数</label>
					  {{scope.row.buyerqita9}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita9buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita9buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita9buyer_imgs[0]"
				      :preview-src-list="scope.row.qita9buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  <!-- 其他10 -->
	      <div class="infoDetail" v-if="scope.row.salesqita10 > 0 || scope.row.qita10sales_imgs[0]">
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita10name+'销售额('+scope.row.salesqita10+')')">
					  <label>{{scope.row.qita10name}}销售额</label>
					  {{scope.row.salesqita10}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita10sales_imgs)">
				    <el-image
				      v-if="scope.row.qita10sales_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita10sales_imgs[0]"
				      :preview-src-list="scope.row.qita10sales_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
			  <div class="infoDetailItem">
				  <div class="infoDetailItemText" @click.stop="copyVal(scope.row.qita10name+'买家数('+scope.row.buyerqita10+')')">
					  <label>{{scope.row.qita10name}}买家数</label>
					  {{scope.row.buyerqita10}}
				  </div>
				  <div class="img-show" @click.stop="copyVal(scope.row.qita10buyer_imgs)">
				    <el-image
				      v-if="scope.row.qita10buyer_imgs[0] != null"
				      width="75%"
				      contain
				      class="image-slot"
				      :src="scope.row.qita10buyer_imgs[0]"
				      :preview-src-list="scope.row.qita10buyer_imgs"
				      fit="cover"
				    ></el-image>
					<div v-else slot="error" class="image-slot">
					  <i class="el-icon-picture-outline"></i>
					</div>
				  </div>
			  </div>
		  </div>
		  
	    </template>
	  </el-table-column>
	  
	  <el-table-column
	    prop="business_license_imgs"
	    label="承诺书"
	    align="center"
	     width="120"
	    show-overflow-tooltip
	  >
	    <template slot-scope="scope">
	      <div class="img-show">
	        <el-image
	          v-if="scope.row.business_license_imgs[0] != null"
	          width="75%"
	          contain
	          class="image-slot"
	          :src="scope.row.business_license_imgs[0]"
	          :preview-src-list="scope.row.business_license_imgs"
	          fit="cover"
	        ></el-image>
	        <div v-else slot="error" class="image-slot">
	          <i class="el-icon-picture-outline"></i>
	        </div>
	      </div>
	    </template>
	  </el-table-column>
	  
	  <el-table-column label="操作" width="100" align="center">
	    <template slot-scope="scope">
	      <el-link
	        type="primary"
	        :underline="false"
	        size="mini"
	        plain
	        class="delete-btn"
	        @click="deleteActivities(scope.row.id)"
	      >
	        删除
	      </el-link>
	  
	      <el-link
	        type="primary"
	        size="mini"
	        :underline="false"
	        plain
	        class="btns"
	        @click="exportText(scope.row)"
	      >
	        导出
	      </el-link>
	    </template>
	  </el-table-column>
    </el-table>

    <!-- 报名列表分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="personTotal"
      @current-change="pageChange"
      :page-size="signInfo.commonDto.limit"
      :current-page="signInfo.commonDto.page"
    >
    </el-pagination>


    <!-- 视频播放弹出框 -->
    <!-- <el-dialog
      title="视频播放"
      :visible.sync="dialogVideoVisible"
      @close="parseVideo"
    >
      <video
        :src="videoUrl"
        controls
        :style="{ width: '100%', 'max-height': '400px' }"
        id="video-play"
      ></video>
    </el-dialog> -->
    <!-- 审核新添加列表的弹框 -->
    <!-- <check-status
            :check-query="checkQuery"
            ref="checkRef"
            @updateComputed="getPersonList()"
        /> -->
  </div>
</template>

<script>
import { showcontent } from "@/utils/method.js";
// import AddOrUpdate from "@/views/modules/config/child-components/activities-add-or-tongji";
// import table2excel from "js-table2excel";
import getCityCode from "@/utils/cityCode.js";
import axios from "axios";
// import JSZip from 'jszip';
// import FileSaver from 'file-saver';
export default {
  data() {
    return {
      dialogVideoVisible: false,
      videoUrl: "",
      userName: "",
	  companyName: "",
      cityCode: "",
      // 城市编码对象列表
      codeListObj: [],
      // 城市编码数组列表
      codeListArr: [],
      phone: "",
      activitiesids: "",
      addOrUpdateVisible: false,
      //对话框是否展示
      dialogTableVisible: false,
      // 获取报名信息列表参数
      personQuery: {
        acid: null,
      },
      // 报名信息列表
      personList: [],
      mubanlist: [],
      // 报名总人数
      personTotal: 0,
      // 活动名称
      activitiesName: "",
      //  要删除的数据数组/批量审核的数组
      deleteIds: [],
      //报名列表查询条件
      signInfo: {
        activitiesId: null,
        userName: "",
        companyName: "",
        // phone: "",
        cityCode: "",
        type: "",
        commonDto: {
          limit: 10,
          page: 1,
        },
        userType: "",
        verifyStatus: "",
        startTime: "",
        endTime: "",
        cityCode: "",
      },
      // const excelName = "boy";
      // table2excel(column, data, excelName);
      // 用户职业信息列表
      // occupInfo: [
      //   { name: "在校学生", id: "1" },
      //   { name: "社会人士", id: "2" },
      // ],
      // 审核状态信息
      // stateInfo: [
      //   { name: "待审核", id: "0" },
      //   { name: "审核通过", id: "1" },
      //   { name: "审核不通过", id: "2" },
      // ],
      // 批量审核的参数
      // mutiAuditQuery: {
      //   context: "",
      //   status: "",
      // },
      // 控制审核不通过描述框的显示与隐藏
      // examDialogVisible: false,
      // 城市信息列表
      // cityCodeList: [],
      // 日期时间选择框的值
      // valueDate: [],
      // 加载组件的显示隐藏
      // loading: false,
    };
  },
  created() {
    this.initList();
    this.init();
	
	getCityCode().then((data) => {
	  this.codeListObj = data[0];
	  this.codeListArr = data[1];
	});
    // this.getCityCode();
  },
  // computed: {
  //   //   对字符串进行转义
  //   escopeObj() {
  //     return (str) => {
  //       return JSON.parse(showcontent(showcontent(str)));
  //     };
  //   },
  //   // 计算所属城市
  //   cityName() {
  //     return (code) => {
  //       return this.cityCodeList.find((item) => item.code === code);
  //     };
  //   },
  // },
  methods: {
	// 复制操作
	copyVal(context) {
		// 创建输入框元素
		let oInput = document.createElement('input');
		// 将想要复制的值
		oInput.value = context;
		// 页面底部追加输入框
		document.body.appendChild(oInput);
		// 选中输入框
		oInput.select();
		// 执行浏览器复制命令
		document.execCommand('Copy');
		// 弹出复制成功信息
		this.$message.success('复制成功');
		// 复制后移除输入框
		oInput.remove();
	},
	exportText (dataStr) {
	  const name = dataStr.company_name;
	  const element = document.createElement('a')
	  const cityName = dataStr.city_code > 0 ? this.codeListObj[dataStr.city_code] : "未录入"
	  var con = ""
	  if(dataStr.salestaobao > 0) {
		  con = con+"\n淘宝销售额: ¥"+dataStr.salestaobao+"元"+
		  "\n淘宝买家数: "+dataStr.buyertaobao+"人"
	  }
	  if(dataStr.salestianmao > 0) {
		  con = con+ "\n天猫销售额: ¥"+dataStr.salestianmao+"元"+
		  "\n天猫买家数: "+dataStr.buyertianmao+"人"
	  }
	  if(dataStr.salespinduoduo > 0) {
		  con = con+ "\n拼多多销售额: ¥"+dataStr.salespinduoduo+"元"+
		  "\n拼多多买家数: "+dataStr.buyerpinduoduo+"人"
	  }
	  if(dataStr.salesjingdong > 0) {
		  con = con+ "\n京东销售额: ¥"+dataStr.salesjingdong+"元"+
		  "\n京东买家数: "+dataStr.buyerjingdong+"人"
	  }
	  if(dataStr.salesdouyin > 0) {
		  con = con+ "\n抖音销售额: ¥"+dataStr.salesdouyin+"元"+
		  "\n抖音买家数: "+dataStr.buyerdouyin+"人"
	  }
	  if(dataStr.saleskuaishou > 0) {
		  con = con+ "\n快手销售额: ¥"+dataStr.saleskuaishou+"元"+
		  "\n快手买家数: "+dataStr.buyerkuaishou+"人"
	  }
	  if(dataStr.salesqita1 > 0) {
		  con = con+ "\n"+dataStr.qita1name+"销售额: ¥"+dataStr.salesqita1+"元"+
		  "\n"+dataStr.qita1name+"买家数: "+dataStr.buyerqita1+"人"
	  }
	  if(dataStr.salesqita2 > 0) {
		  con = con+ "\n"+dataStr.qita2name+"销售额: ¥"+dataStr.salesqita2+"元"+
		  "\n"+dataStr.qita2name+"买家数: "+dataStr.buyerqita2+"人"
	  }
	  if(dataStr.salesqita3 > 0) {
		  con = con+ "\n"+dataStr.qita3name+"销售额: ¥"+dataStr.salesqita3+"元"+
		  "\n"+dataStr.qita3name+"买家数: "+dataStr.buyerqita3+"人"
	  }
	  if(dataStr.salesqita4 > 0) {
		  con = con+ "\n"+dataStr.qita4name+"销售额: ¥"+dataStr.salesqita4+"元"+
		  "\n"+dataStr.qita4name+"买家数: "+dataStr.buyerqita4+"人"
	  }
	  if(dataStr.salesqita5 > 0) {
		  con = con+ "\n"+dataStr.qita5name+"销售额: ¥"+dataStr.salesqita5+"元"+
		  "\n"+dataStr.qita5name+"买家数: "+dataStr.buyerqita5+"人"
	  }
	  if(dataStr.salesqita6 > 0) {
		  con = con+ "\n"+dataStr.qita6name+"销售额: ¥"+dataStr.salesqita6+"元"+
		  "\n"+dataStr.qita7name+"买家数: "+dataStr.buyerqita6+"人"
	  }
	  if(dataStr.salesqita7 > 0) {
		  con = con+ "\n"+dataStr.qita7name+"销售额: ¥"+dataStr.salesqita7+"元"+
		  "\n"+dataStr.qita7name+"买家数: "+dataStr.buyerqita7+"人"
	  }
	  if(dataStr.salesqita8 > 0) {
		  con = con+ "\n"+dataStr.qita8name+"销售额: ¥"+dataStr.salesqita8+"元"+
		  "\n"+dataStr.qita8name+"买家数: "+dataStr.buyerqita8+"人"
	  }
	  if(dataStr.salesqita9 > 0) {
		  con = con+ "\n"+dataStr.qita9name+"销售额: ¥"+dataStr.salesqita9+"元"+
		  "\n"+dataStr.qita9name+"买家数: "+dataStr.buyerqita9+"人"
	  }
	  if(dataStr.salesqita10 > 0) {
		  con = con+ "\n"+dataStr.qita10name+"销售额: ¥"+dataStr.salesqita10+"元"+
		  "\n"+dataStr.qita10name+"买家数: "+dataStr.buyerqita10+"人"
	  }
	  const dtext = "申报单位: "+dataStr.company_name+
	  "\n姓名: "+dataStr.contact_user+
	  "\n电话: "+dataStr.contact_phone+
	  "\n产品名称: "+dataStr.product_name+
	  "\n上传时间: "+dataStr.create_time+
	  "\n平台: "+dataStr.pingtai+
	  "\n城市: "+cityName+con+
	  "\n公司简介: "+dataStr.aboutus
	  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(dtext))
	  element.setAttribute('download', name)
	  element.style.display = 'none'
	  element.click()
	},
    // 删除上传记录
    deleteActivities(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
		    let app=this
		    let xhr = new XMLHttpRequest();
		    xhr.open('POST', 'https://activity.suhoo.netindex.php?s=/api/activity/delete', true);
		    xhr.setRequestHeader('Content-type', 'application/json');
		    xhr.onreadystatechange = function () {
		    		  var res = JSON.parse(xhr.response);
		    		  if (res.status === 200) {
					  // console.log(res);
						  app.$nextTick(() =>{
							app.initList(1)
						  })
						  
					      app.$message({
					        type: "success",
					        message: "删除成功!",
					      });
		  			
		  			// const data = res.data;
		  			// const url = window.URL.createObjectURL(
		  			//   new Blob([data], { type: "application/vnd.ms-excel" })
		  			// );
		  			// const link = document.createElement("a");
		  			// link.style.display = "none";
		  			// link.href = url;
		  			// link.download = "成绩列表";
		  			// document.body.appendChild(link);
		  			// link.click();
		  			// document.body.removeChild(link);
		  			
		    		  } else {
		    			app.activesStop = 1
		    			console.log(app.activesStop)
		    			Toast.fail(res.message);
		    		  }
		    };
		    
		    xhr.send(JSON.stringify({
		    	aId: id,
		    }));
		    
		    this.$nextTick(() => {
		    		this.$loading().close()
		    })
			
          // this.$ajaxPost("/activities/delete", {}, { id }).then(({ data }) => {
          //   if (data.code === 0) {
          //     this.getActivitiesList();
          //     this.getAllCourseList();
          //     this.$message({
          //       type: "success",
          //       message: "删除成功!",
          //     });
          //   }
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    chongzhi() {
	  this.companyName = '',
      this.userName = '',
      this.cityCode = '',
      this.phone = ""
	  this.$nextTick(() =>{
	    this.initList()
	  })
    },
    // // 新增或修改活动赛事
    // addOrUpdateHandle(id) {
    //   this.addOrUpdateVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.addOrUpdateRef.init(id);
    //   });
    // },
    // showcontent,
    // init() {
    //   this.personQuery.acid = this.$route.params.id;
    //   this.signInfo.activitiesId = parseInt(this.$route.params.id);
    //   this.getPersonList();
    //   this.getactivelist(this.signInfo.activitiesId);
    // },
    // getactivelist(id) {
    //   this.$ajaxGet("/activities/info/open/" + id).then(({ data }) => {
    //     console.log(data);
    //     this.templateId = data.data.templateId;
    //     this.getmubanlist(this.templateId);
    //     this.activitiesids = data.data.id;
    //   });
    // },
    // getmubanlist(id) {
    //   if (id) {
    //     this.$ajaxGet("/registrationTemplate/getById/open?id=" + id).then(
    //       ({ data }) => {
    //         console.log(data);
    //         this.mubanlist = JSON.parse(showcontent(data.data.content));
    //       }
    //     );
    //   }
    // },
    // 播放视频
    videoPlay(url) {
      this.videoUrl = url;
      this.dialogVideoVisible = true;
    },
    parseVideo() {
      // 关闭对话框暂停视频
      const id = document.querySelector("#video-play");
      id.pause();
    },
    // 成绩导出
    getcommand() {
	  let app=this
	  let xhr = new XMLHttpRequest();
	  xhr.open('POST', 'https://activity.suhoo.netindex.php?s=/api/activity/excel', true);
	  xhr.setRequestHeader('Content-type', 'application/json');
	  xhr.onreadystatechange = function () {
	  		  var res = JSON.parse(xhr.response);
	  		  if (res.status === 200) {
				console.log(res);
				
				// const data = res.data;
				// const url = window.URL.createObjectURL(
				//   new Blob([data], { type: "application/vnd.ms-excel" })
				// );
				// const link = document.createElement("a");
				// link.style.display = "none";
				// link.href = url;
				// link.download = "成绩列表";
				// document.body.appendChild(link);
				// link.click();
				// document.body.removeChild(link);
				
	  		  } else {
	  			app.activesStop = 1
	  			console.log(app.activesStop)
	  			Toast.fail(res.message);
	  		  }
	  };
	  
	  xhr.send(JSON.stringify({
	  	activityId: this.personQuery.acid.toString(),
	  	phone: this.phone,
		companyName: this.companyName,
	  	username: this.userName,
	  	cityCode: this.cityCode,
	  }));
	  
	  this.$nextTick(() => {
	  		this.$loading().close()
	  })
    },
    init() {
      this.personQuery.acid = this.$route.params.id;
    },
    // 获取信息详情
    initList(a) {
		if (a == 1) {
		  this.signInfo.commonDto.page = 1;
		}
		let app = this
		let xhr = new XMLHttpRequest();
		xhr.open('POST', 'https://activity.suhoo.netindex.php?s=/api/activity/uploadList', true);
		xhr.setRequestHeader('Content-type', 'application/json');
		xhr.onreadystatechange = function () {
		  let res = JSON.parse(xhr.response);
		  if (res.status === 200) {
			let data = res.data.list
			app.setList(data)
		  } else {
			app.activesStop = 1
			console.log(app.activesStop)
			Toast.fail(res.message);
		  }
		};
		
		xhr.send(JSON.stringify({
			page: this.signInfo.commonDto.page,
			limit: this.signInfo.commonDto.limit,
			activityId: this.$route.params.id,
			phone: this.phone,
			companyname: this.companyName,
			username: this.userName,
			citycode: this.cityCode,
		}));
    },
	async setList(data) {
	  let pList = [];
	  for (let index = 0; index < data.data.length; index++) {
		const element = data.data[index];
		const list = {};
		list.id = element.id;
		list.company_name = element.company_name;
		list.product_name = element.product_name;
		list.contact_user = element.contact_user;
		list.contact_phone = element.contact_phone;
		list.city_code = element.city_code;
		list.create_time = element.create_time;
		
		list.pingtai = JSON.parse(element.pingtai);
		
		list.salestaobao = element.salestaobao;
		list.taobaosales_imgs = JSON.parse(element.taobaosales_imgs);
		list.buyertaobao = element.buyertaobao;
		list.taobaobuyer_imgs = JSON.parse(element.taobaobuyer_imgs);
		
		list.salestianmao = element.salestianmao;
		list.tianmaosales_imgs = JSON.parse(element.tianmaosales_imgs);
		list.buyertianmao = element.buyertianmao;
		list.tianmaobuyer_imgs = JSON.parse(element.tianmaobuyer_imgs);
		
		list.salespinduoduo  = element.salespinduoduo;
		list.pinduoduosales_imgs  = JSON.parse(element.pinduoduosales_imgs);
		list.buyerpinduoduo  = element.buyerpinduoduo;
		list.pinduoduobuyer_imgs  = JSON.parse(element.pinduoduobuyer_imgs);
		
		list.salesjingdong  = element.salesjingdong;
		list.jingdongsales_imgs  = JSON.parse(element.jingdongsales_imgs);
		list.buyerjingdong  = element.buyerjingdong;
		list.jingdongbuyer_imgs  = JSON.parse(element.jingdongbuyer_imgs);
		
		list.salesdouyin  = element.salesdouyin;
		list.douyinsales_imgs  = JSON.parse(element.douyinsales_imgs);
		list.buyerdouyin  = element.buyerdouyin;
		list.douyinbuyer_imgs  = JSON.parse(element.douyinbuyer_imgs);
		
		list.saleskuaishou  = element.saleskuaishou;
		list.kuaishousales_imgs  = JSON.parse(element.kuaishousales_imgs);
		list.buyerkuaishou  = element.buyerkuaishou;
		list.kuaishoubuyer_imgs  = JSON.parse(element.kuaishoubuyer_imgs);
		
		list.qita1name  = element.qita1name;
		list.salesqita1  = element.salesqita1;
		list.qita1sales_imgs  = JSON.parse(element.qita1sales_imgs);
		list.buyerqita1  = element.buyerqita1;
		list.qita1buyer_imgs  = JSON.parse(element.qita1buyer_imgs);
		
		list.qita2name  = element.qita2name;
		list.salesqita2  = element.salesqita2;
		list.qita2sales_imgs  = JSON.parse(element.qita2sales_imgs);
		list.buyerqita2  = element.buyerqita2;
		list.qita2buyer_imgs  = JSON.parse(element.qita2buyer_imgs);
		
		list.qita3name  = element.qita3name;
		list.salesqita3  = element.salesqita3;
		list.qita3sales_imgs  = JSON.parse(element.qita3sales_imgs);
		list.buyerqita3  = element.buyerqita3;
		list.qita3buyer_imgs  = JSON.parse(element.qita3buyer_imgs);
		
		list.qita4name  = element.qita4name;
		list.salesqita4  = element.salesqita4;
		list.qita4sales_imgs  = JSON.parse(element.qita4sales_imgs);
		list.buyerqita4  = element.buyerqita4;
		list.qita4buyer_imgs  = JSON.parse(element.qita4buyer_imgs);
		
		list.qita5name  = element.qita5name;
		list.salesqita5  = element.salesqita5;
		list.qita5sales_imgs  = JSON.parse(element.qita5sales_imgs);
		list.buyerqita5  = element.buyerqita5;
		list.qita5buyer_imgs  = JSON.parse(element.qita5buyer_imgs);
		
		list.qita6name  = element.qita6name;
		list.salesqita6  = element.salesqita6;
		list.qita6sales_imgs  = JSON.parse(element.qita6sales_imgs);
		list.buyerqita6  = element.buyerqita6;
		list.qita6buyer_imgs  = JSON.parse(element.qita6buyer_imgs);
		
		list.qita7name  = element.qita7name;
		list.salesqita7  = element.salesqita7;
		list.qita7sales_imgs  = JSON.parse(element.qita7sales_imgs);
		list.buyerqita7  = element.buyerqita7;
		list.qita7buyer_imgs  = JSON.parse(element.qita7buyer_imgs);
		
		list.qita8name  = element.qita8name;
		list.salesqita8  = element.salesqita8;
		list.qita8sales_imgs  = JSON.parse(element.qita8sales_imgs);
		list.buyerqita8  = element.buyerqita8;
		list.qita8buyer_imgs  = JSON.parse(element.qita8buyer_imgs);
		
		list.qita9name  = element.qita9name;
		list.salesqita9  = element.salesqita9;
		list.qita9sales_imgs  = JSON.parse(element.qita9sales_imgs);
		list.buyerqita9  = element.buyerqita9;
		list.qita9buyer_imgs  = JSON.parse(element.qita9buyer_imgs);
		
		list.qita10name  = element.qita10name;
		list.salesqita10  = element.salesqita10;
		list.qita10sales_imgs  = JSON.parse(element.qita10sales_imgs);
		list.buyerqita10  = element.buyerqita10;
		list.qita10buyer_imgs  = JSON.parse(element.qita10buyer_imgs);
		
		list.business_license_imgs  = JSON.parse(element.business_license_imgs);
		list.aboutus  = element.aboutus;
		
		pList.push(list);
	  }
	  this.personTotal = Number(data.total)
	  // this.personList = JSON.parse(JSON.stringify(this.personList, null, 4))
	  console.log(pList)
	  let app = this
	  app.$nextTick(() => {
		app.$loading().close()
		app.personList = pList
	  })
	},
    // 分页器页数改变时触发
    pageChange(val) {
      this.signInfo.commonDto.page = val;
      // this.getPersonList();
      this.initList();
    },
    // 返回上一个页面
    goBack() {
      this.$router.back();
    },
    // // 日期变化
    // dateChange(val) {
    //   if (val) {
    //     this.signInfo.startTime = val[0];
    //     this.signInfo.endTime = val[1];
    //   } else {
    //     this.signInfo.startTime = "";
    //     this.signInfo.endTime = "";
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-icon-circle-close {
  color: white;
}
.detail-sign-info {
  background: #fff;
  padding: 15px 20px;
}
.namee {
  width: 130px;
}
@primaryColor: #409eff;
.img-show {
  display: flex;
  height: 130px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.seach {
  width: 130%;
}
/deep/.el-row--flex {
  display: block;
}
.heard {
  display: flex;
  justify-content: space-between;
}
/deep/.el-table {
  font-size: 14px;
}
.check-btns {
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    color: @primaryColor;
    font-size: 12px;
    cursor: pointer;
    &:first-child:hover {
      color: #67c23a;
    }
    &:last-child:hover {
      color: #f56c6c;
    }
  }
}
.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 12px;
    color: @primaryColor;
    cursor: pointer;
  }
}
.img-content {
  width: 40px;
  height: 40px;
}
/deep/ .el-table__body-wrapper {
  overflow-y: auto;
}
.row-bg {
  .el-col-22 {
    .el-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
/deep/ .user-name .el-input__inner {
  width: 100px;
}
/deep/ .paltform-name .el-input__inner {
  width: 120px;
}
/deep/ .option-width {
  // margin-left: 10px;
  .el-input {
    .el-input__inner {
      width: 120px;
    }
  }
}
.primary {
  color: #007acc;
}
.sign-form {
  .top-box,
  .bottom-box {
    display: flex;
    .item_bto {
      margin-left: 5px;
    }
  }
}
.infoDetail{
	width: 33.3333%;display: inline-block;float: left;overflow: hidden;
	.infoDetailItem{
		width: 50%;display: inline-block;float: left;box-sizing: border-box;padding: 5px;
		line-height: 40px;height: 140px;
		.infoDetailItemText{
		  display: block;
		  text-align: left;
		  line-height: 20px;min-height: 52px;
		  color: #007acc;font-size: 15px;font-weight: bold;padding: 5px 5px 5px 10px;
		  border: 1px solid #dbdbdb;border-bottom: 0;
		  label{
			  font-size: 12px;color: #333;font-weight: 400;display: block;
		  }
		}
		.img-show {
		  height: 80px;overflow: hidden;
		  width: 100%;background-color: #fff;border: 1px solid #dbdbdb;position: relative;
		}
	}
}
</style>